import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import './index.css';
import EventReporter from './appEvents';
import App from './App';
import {
  ENV,
  APP_VERSION,
  // IS_PROD,
  CORE_API_URL,
  CLIENT_API_URL,
  REACT_APP_SENTRY_DNS,
  REACT_APP_SENTRY_TRACESSAMPLERATE,
} from './config';
import { setClientAuthToken } from './api/ClientInstance';
import * as serviceWorker from './serviceWorker';
// import * as Sentry from '@sentry/browser';

import { APP_SECTIONS_PATHS } from './constants/routes';
import './i18n';

(async () => {
  await import('./normalize.css');
  await import('./App.css');
  await import('./fonts/proximanova/proximanova.css');
})();

window.Classrooms = {
  appVersion: APP_VERSION,
  environment: ENV,
  coreApiUrl: CORE_API_URL,
  clientApiUrl: CLIENT_API_URL,
};

const urlParams = new URLSearchParams(window.location.search);
const emailUserIsConfirmed = urlParams.get('confirmed');

if (emailUserIsConfirmed) {
  localStorage.setItem('isPendingShowAccountConfirmed', 'true');
  localStorage.setItem('user_confirmed', 'true');
  localStorage.setItem('selectedGroupId', '');
  window.location.assign(APP_SECTIONS_PATHS.BASE_APP);
}

const authToken = localStorage.getItem('auth_token');
const userEmail = localStorage.getItem('user_email');
if (authToken) {
  setClientAuthToken(authToken, userEmail);
}

// if (IS_PROD) {
//   // if (authToken) {
//   //   setClientAuthToken(authToken, userEmail);
//   // }
//   // else {
//   //   window.location.assign(window.location.origin);
//   // }
// }

// Initialize Event Trackers
console.info('%c ℹ️ EVENT_REPORTER INITIALIZED', 'background: #006579; color: #c2f5ff; font-size: 12px');
EventReporter.initialize();

Sentry.init({
  dsn: REACT_APP_SENTRY_DNS,
  integrations: [new BrowserTracing()],
  environment: ENV,
  release: APP_VERSION,
  tracesSampleRate: REACT_APP_SENTRY_TRACESSAMPLERATE || 1.0,
});

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
